export const PROFS = ["welder", "co2_welder", "orbital_welder", "pipefitter", "fitter", "uhp", "clean_room", "hvac"];
export const LEVELS = ["beginner", "experienced", "professional"];

const BASE = "https://saubereko.eu/hall-of-fame";

export function buildCandidatesUrl({ skills = [], prof = "", level = "" }) {
  const q = [];
  if (skills.length) q.push(`skills=${skills.map(encodeURIComponent).join(",")}`);
  if (prof) {
    q.push(`prof=${encodeURIComponent(prof)}`);
    if (level) q.push(`level=${encodeURIComponent(level)}`);
  }
  return `${BASE}${q.length ? `?${q.join("&")}` : ""}#rozsirene`;
}

const mk = (eyebrow, title, prof, level, skills, btn, info, profs, levels) => ({
  eyebrow, title, prof, level, skills, btn, info,
  profs: Object.fromEntries(PROFS.map((p, i) => [p, profs[i]])),
  levels: Object.fromEntries(LEVELS.map((l, i) => [l, levels[i]])),
});

export const CS_TR = {
  sk: mk("Pre firmy", "Hľadáte certifikovaných profesionálov?", "Profesia (voliteľné)", "Minimálna úroveň", "Zručnosti (voliteľné)",
    "Hľadať kandidátov na SauberEko®",
    "Zobraziť dostupných kandidátov – počet uvidíte zdarma. Registrovaná firma: 20 € za 24 h plného prístupu. Bez registrácie: 50 €. Firmy so zlatým certifikátom SauberEko® majú prístup zdarma.",
    ["Zvárač TIG", "Zvárač CO2", "Orbitálny zvárač", "Potrubár", "Montér", "UHP", "Clean room", "HVAC"],
    ["Začiatočník", "Skúsený", "Profesionál"]),
  en: mk("For companies", "Looking for certified professionals?", "Profession (optional)", "Minimum level", "Skills (optional)",
    "Find candidates on SauberEko®",
    "View available candidates – the count is free. Registered company: €20 for 24 h full access. Without registration: €50. Companies with a SauberEko® gold certificate get access for free.",
    ["TIG welder", "CO2 welder", "Orbital welder", "Pipefitter", "Fitter", "UHP", "Clean room", "HVAC"],
    ["Beginner", "Experienced", "Professional"]),
  cs: mk("Pro firmy", "Hledáte certifikované profesionály?", "Profese (volitelné)", "Minimální úroveň", "Dovednosti (volitelné)",
    "Hledat kandidáty na SauberEko®",
    "Zobrazit dostupné kandidáty – počet uvidíte zdarma. Registrovaná firma: 20 € za 24 h plného přístupu. Bez registrace: 50 €. Firmy se zlatým certifikátem SauberEko® mají přístup zdarma.",
    ["Svářeč TIG", "Svářeč CO2", "Orbitální svářeč", "Potrubář", "Montér", "UHP", "Clean room", "HVAC"],
    ["Začátečník", "Zkušený", "Profesionál"]),
  de: mk("Für Firmen", "Sie suchen zertifizierte Fachkräfte?", "Beruf (optional)", "Mindestniveau", "Fähigkeiten (optional)",
    "Kandidaten auf SauberEko® suchen",
    "Verfügbare Kandidaten anzeigen – die Anzahl sehen Sie kostenlos. Registrierte Firma: 20 € für 24 h Vollzugriff. Ohne Registrierung: 50 €. Firmen mit goldenem SauberEko®-Zertifikat haben kostenlosen Zugang.",
    ["WIG-Schweißer", "MAG-Schweißer", "Orbitalschweißer", "Rohrleger", "Monteur", "UHP", "Reinraum", "HLK"],
    ["Einsteiger", "Erfahren", "Profi"]),
  pl: mk("Dla firm", "Szukacie certyfikowanych profesjonalistów?", "Zawód (opcjonalnie)", "Minimalny poziom", "Umiejętności (opcjonalnie)",
    "Szukaj kandydatów na SauberEko®",
    "Pokaż dostępnych kandydatów – liczbę zobaczysz za darmo. Zarejestrowana firma: 20 € za 24 h pełnego dostępu. Bez rejestracji: 50 €. Firmy ze złotym certyfikatem SauberEko® mają dostęp za darmo.",
    ["Spawacz TIG", "Spawacz CO2", "Spawacz orbitalny", "Rurarz", "Monter", "UHP", "Clean room", "HVAC"],
    ["Początkujący", "Doświadczony", "Profesjonalista"]),
  fr: mk("Pour les entreprises", "Vous cherchez des professionnels certifiés ?", "Métier (facultatif)", "Niveau minimum", "Compétences (facultatif)",
    "Trouver des candidats sur SauberEko®",
    "Afficher les candidats disponibles – le nombre est gratuit. Entreprise inscrite : 20 € pour 24 h d'accès complet. Sans inscription : 50 €. Les entreprises avec le certificat d'or SauberEko® ont un accès gratuit.",
    ["Soudeur TIG", "Soudeur CO2", "Soudeur orbital", "Tuyauteur", "Monteur", "UHP", "Salle blanche", "CVC"],
    ["Débutant", "Expérimenté", "Professionnel"]),
};
